{
 "z06-toll-shelter": {"perspective": [100, 1000, 0.9, 1.06], "ground": [960, 700], "haze": [1300, 60], "fog": 0.1},
 "z06-broken-span": {"perspective": [60, 520, 0.92, 1.02], "ground": [352, 300], "haze": [700, 60], "fog": 0.1},
 "z06-repair-camp": {"perspective": [240, 1000, 0.94, 1.06], "ground": [640, 560], "haze": [1400, 60], "fog": 0.06, "desaturation": 0.2},
 "z06-old-ford": {"perspective": [60, 1000, 0.88, 1.06], "ground": [400, 600], "haze": [600, 300], "fog": 0.12}
}
